import styled from 'styled-components'

export const DashboardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 84px;
  height: 100%;
`

interface DashboardWidgetProps {
  primaryColor: string
  secondaryColor: string
  textColor: string
}

export const DashboardWidget = styled.div<DashboardWidgetProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;

  height: 125px;
  width: 266px;
  padding-left: 30px;

  border: 2px solid ${(props) => props.secondaryColor};
  border-radius: 16px;
  background-color: ${(props) => props.primaryColor};

  &::before {
    content: '';
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${(props) => props.secondaryColor};
  }

  & > h2 {
    margin-bottom: 0;
    font-size: 34px;
    color: ${(props) => props.textColor};
  }

  & > h3 {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    font-family: GothamHTF, sans-serif;
    color: ${(props) => props.textColor};
  }
`
